import { render, staticRenderFns } from "./accessdenied.vue?vue&type=template&id=469470f0&scoped=true&"
import script from "./accessdenied.vue?vue&type=script&lang=js&"
export * from "./accessdenied.vue?vue&type=script&lang=js&"
import style0 from "./accessdenied.vue?vue&type=style&index=0&id=469470f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469470f0",
  null
  
)

export default component.exports